var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2226_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6093 46.062C26.5628 48.3455 22.4374 48.3455 19.3909 46.062L4.80877 35.132C1.76224 32.8485 0.48745 28.8009 1.65112 25.1061L7.221 7.42098C8.38467 3.72618 11.7221 1.22461 15.4878 1.22461H33.5124C37.2781 1.22461 40.6155 3.72618 41.7792 7.42098L47.3491 25.1061C48.5127 28.8009 47.238 32.8485 44.1914 35.132L29.6093 46.062Z",
    fill: "url(#paint0_linear_2226_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0095 45.2618C26.3184 47.2789 22.6817 47.2789 19.9907 45.2618L5.40854 34.3318C2.70959 32.3088 1.56574 28.706 2.60493 25.4065L8.17482 7.72138C9.21253 4.42651 12.1757 2.22461 15.4878 2.22461H33.5124C36.8245 2.22461 39.7877 4.42651 40.8254 7.72138L46.3953 25.4065C47.4345 28.706 46.2906 32.3088 43.5917 34.3318L29.0095 45.2618Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_angular_2226_130_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.003 -0.003 0 25 24.7998)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1333.33,
    y: -1333.33,
    width: 2666.67,
    height: 2666.67
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(255, 255, 255, 1) 0deg,rgba(224, 224, 224, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 21.9842C24.8243 21.7384 25.1757 21.7384 25.3024 21.9842L26.1074 23.5459C26.1398 23.6088 26.191 23.66 26.2539 23.6924L27.8156 24.4974C28.0615 24.6241 28.0615 24.9755 27.8156 25.1022L26.2539 25.9072C26.191 25.9396 26.1398 25.9908 26.1074 26.0537L25.3024 27.6154C25.1757 27.8613 24.8243 27.8613 24.6976 27.6154L23.8926 26.0537C23.8602 25.9908 23.809 25.9396 23.7461 25.9072L22.1844 25.1022C21.9385 24.9755 21.9385 24.6241 22.1844 24.4974L23.7461 23.6924C23.809 23.66 23.8602 23.6088 23.8926 23.5459L24.6976 21.9842Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.87999999523162842,\"g\":0.87999999523162842,\"b\":0.87999999523162842,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.87999999523162842,\"g\":0.87999999523162842,\"b\":0.87999999523162842,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":3.6739405577555036e-16,\"m01\":-6.0,\"m02\":28.0,\"m10\":6.0,\"m11\":3.6739405577555036e-16,\"m12\":21.79980468750},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint2_angular_2226_130_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.003 0 0 -0.003 25 24.7998)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1333.33,
    y: -1333.33,
    width: 2666.67,
    height: 2666.67
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(255, 255, 255, 1) 0deg,rgba(224, 224, 224, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 0.5
    }
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 21.9842C24.8243 21.7384 25.1757 21.7384 25.3024 21.9842L26.1074 23.5459C26.1398 23.6088 26.191 23.66 26.2539 23.6924L27.8156 24.4974C28.0615 24.6241 28.0615 24.9755 27.8156 25.1022L26.2539 25.9072C26.191 25.9396 26.1398 25.9908 26.1074 26.0537L25.3024 27.6154C25.1757 27.8613 24.8243 27.8613 24.6976 27.6154L23.8926 26.0537C23.8602 25.9908 23.809 25.9396 23.7461 25.9072L22.1844 25.1022C21.9385 24.9755 21.9385 24.6241 22.1844 24.4974L23.7461 23.6924C23.809 23.66 23.8602 23.6088 23.8926 23.5459L24.6976 21.9842Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.87843137979507446,\"g\":0.87843137979507446,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.87843137979507446,\"g\":0.87843137979507446,\"b\":0.87843137979507446,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":-6.0,\"m01\":-6.3918976448557041e-13,\"m02\":28.0,\"m10\":-2.8473786371253917e-13,\"m11\":-6.0,\"m12\":27.79980468750},\"opacity\":0.50,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7469 21.7551C25.434 21.148 24.566 21.148 24.2531 21.7551L23.4716 23.2714L21.9553 24.0529C21.3482 24.3658 21.3482 25.2338 21.9553 25.5467L23.4716 26.3282L24.2531 27.8445C24.566 28.4516 25.434 28.4516 25.7469 27.8445L26.5284 26.3282L28.0447 25.5467C28.6518 25.2338 28.6518 24.3658 28.0447 24.0529L26.5284 23.2714L25.7469 21.7551Z",
    stroke: "black",
    strokeOpacity: 0.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29346 35.4955L38.1688 2.62012C39.8378 3.71256 41.1388 5.38605 41.78 7.42175L44.7442 16.8337L17.1759 44.402L5.29346 35.4955Z",
    fill: "white",
    fillOpacity: 0.32
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2226_130",
    x: 1.2251,
    y: 1.22461,
    width: 46.55,
    height: 47.5498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.300741 0 0 0 0 0.171852 0 0 0 0 0.0192593 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2226_130"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2226_130",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_angular_2226_130_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 21.9842C24.8243 21.7384 25.1757 21.7384 25.3024 21.9842L26.1074 23.5459C26.1398 23.6088 26.191 23.66 26.2539 23.6924L27.8156 24.4974C28.0615 24.6241 28.0615 24.9755 27.8156 25.1022L26.2539 25.9072C26.191 25.9396 26.1398 25.9908 26.1074 26.0537L25.3024 27.6154C25.1757 27.8613 24.8243 27.8613 24.6976 27.6154L23.8926 26.0537C23.8602 25.9908 23.809 25.9396 23.7461 25.9072L22.1844 25.1022C21.9385 24.9755 21.9385 24.6241 22.1844 24.4974L23.7461 23.6924C23.809 23.66 23.8602 23.6088 23.8926 23.5459L24.6976 21.9842Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint2_angular_2226_130_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6976 21.9842C24.8243 21.7384 25.1757 21.7384 25.3024 21.9842L26.1074 23.5459C26.1398 23.6088 26.191 23.66 26.2539 23.6924L27.8156 24.4974C28.0615 24.6241 28.0615 24.9755 27.8156 25.1022L26.2539 25.9072C26.191 25.9396 26.1398 25.9908 26.1074 26.0537L25.3024 27.6154C25.1757 27.8613 24.8243 27.8613 24.6976 27.6154L23.8926 26.0537C23.8602 25.9908 23.809 25.9396 23.7461 25.9072L22.1844 25.1022C21.9385 24.9755 21.9385 24.6241 22.1844 24.4974L23.7461 23.6924C23.809 23.66 23.8602 23.6088 23.8926 23.5459L24.6976 21.9842Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2226_130",
    x1: 24.5007,
    y1: 49.8915,
    x2: 24.5007,
    y2: -3.91337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F4CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop1);
export default __webpack_public_path__ + "static/media/top1.99c541aa571ff29fbdb677facfc76f29.svg";
export { ForwardRef as ReactComponent };